<div style="padding: 10px;">
  <div>
    <img src="assets/images/piccolo-site-logo.png" alt="Piccolo" class="logo">
    <h2 style="font-family:'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif">Signature Creator</h2>
  </div>
</div>
